import React from "react";
import "./OurHistory.css";
import FadeUp from "../FadeUp/FadeUp";

const OurHistory = ({ isAlbanian }) => {
  return (
    <div>
      <div className="ourhistory-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="ourhistory-title">
          <FadeUp>
            {isAlbanian ? "Historia jonë" : "Our History"}
            </FadeUp>
          </div>
          <div className="ourhistory-content">
            <div
              className="ourhistory-right"
            >
              <img
                src="/history.jpg"
                alt="ourhistory-photo"
                className="ourhistory-image"
                loading="lazy"
              />
            </div>
            <div
              className="ourhistory-left"
            >
              <h2>
              <FadeUp>
                {(isAlbanian
                  ? `Historia e Vila-L filloi me themelimin e saj në vitin 2002 nga Z. Lazër Mhilli, me profesion ekonomist. Që në fillimet e tij, ai hodhi hapa të rëndësishëm në sektorin e ndërtimit, duke vendosur themelet e një kompanie që sot është një nga kompanitë lider në këtë fushë.\n
    Suksesi i parë i Vila-L erdhi në vitin 2007 me ndërtimin e një objekti rezidencial 9-katësh në zonën e Astirit. Ky projekt ishte pika e nisjes për një rrugëtim të suksesshëm, duke sjellë realizimin e shumë ndërtesave rezidenciale në zona të ndryshme të Tiranës, si Astir, Fresk, Rruga “5 Maji” dhe Don Bosko.\n
    Gjithashtu, kompania është zgjeruar përtej kufijve të Shqipërisë, me dy projekte ndërtimi në Malin e Zi, duke shënuar një hap të rëndësishëm në rritjen dhe zhvillimin e saj.\n 
    Sot, Vila-L vazhdon të operojë me të njëjtin pasion dhe përkushtim si në fillimet e saj, falë vlerave të forta, motivimit dhe vizionit të Z. Lazër Mhilli, i cili frymëzon punonjësit e kompanisë drejt standardeve më të larta në punë.`
                  : `The history of Vila-L began with its establishment in 2002 by Mr. Lazër Mhilli, an economist by profession. From the very beginning, he took significant steps in the construction sector, laying the foundations of a company that today stands as a leader in the field.\n
    Vila-L’s first major success came in 2007 with the construction of a nine-story residential building in the Astir area. This project marked the starting point of a successful journey, leading to the development of numerous residential buildings in various parts of Tirana, including Astir, Fresk, “5 Maji” Street, and Don Bosko.\n
    Additionally, the company has expanded beyond Albania’s borders with two construction projects in Montenegro, marking an important milestone in its growth and development.\n 
    Today, Vila-L continues to operate with the same passion and dedication as in its early days, driven by strong values, motivation, and the vision of Mr. Lazër Mhilli, who inspires employees to uphold the highest standards at work.`
                )
                  .split("\n")
                  .map((text, index) => (
                    <span key={index}>
                      {text}
                      <br />
                    </span>
                  ))}
                  </FadeUp>
              </h2>
            </div>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default OurHistory;
